import React from "react";
import styled from "styled-components";
import noImage from 'assets/empty.png';
import './tools_pane_style.css'
import {Flex} from "../common_style/flex";
import {TabContainer} from "./tools_pane_styles";
import {Span} from "../common_style/text";
import {Colors, FontStyles} from "../constants";
import {
    backgrounds,
    objects,
    characters,
    textBoxes,
    preloadImage,
    fullTextBoxes,
    objectsOrdering,
    hiddenTextboxes
} from "./tools_items";
import {DragPreviewImage, useDrag} from "react-dnd";
import Types from 'components/editor_canvas/editor_canvas_element_types';
import {placedButtonPosition, placedButtons} from "components/placed_item/placed_item_view";
import {ReactComponent as Close} from "../../assets/icons/close_primary.svg";
import {Localization} from "localizations/languages";

function getTab(text, active, onClick) {
    return <TabContainer style={{borderBottom: active ? 'solid 2px ' + Colors.button : null}} onClick={onClick}>
        <Span textStyle={FontStyles.button}>{text}</Span>
    </TabContainer>
}

let bgs;
let objs;
let chrs;
let tbs;

let bgHandler;
let parentKey;

function getDragSpec(props, asset, objType, meta) {
    return {
        item: {type: Types.ELEMENT, asset: asset, objType: objType, asset_n: asset.i, meta: meta},
        begin: (m) => props.onDragStart(),
        end: (i, m) => props.onDragEnd(),
        collect: monitor => ({
            isDragging: !!monitor.isDragging(),
        }),
    };
}

function getTabContent(props, selected) {
    bgHandler = props.bgClick;
    if (parentKey !== props.parentKey) {
        bgs = null;
        objs = null;
        chrs = null;
        tbs = null;
        parentKey = props.parentKey;
    }
    if (!bgs) bgs = backgrounds.map((b) => <div key={b.i} className='bg-thumb'
                                                onMouseEnter={() => preloadImage(b.img)}
                                                style={{backgroundImage: 'url(' + b.thumb + ')'}}
                                                onClick={() => bgHandler(b.i)}/>);
    if (!objs) objs = objectsOrdering.map((i, _) => {
        let b = objects[i];
        if (b === undefined) {
            console.log(i);
        }
        const [{isDragging}, drag, preview] = useDrag(getDragSpec(props, b, Types.PLACED_OBJECT));
        return <div onMouseEnter={() => preloadImage(b.img)} key={'object-' + b.i}><DragPreviewImage connect={preview}
                                                                                                     src={noImage}/>
            <div ref={drag} className='obj-thumb' style={{backgroundImage: 'url(' + b.thumb + ')'}}/>
        </div>;
    });
    if (!chrs) chrs = characters.map((b) => {
        const [{isDragging}, drag, preview] = useDrag(getDragSpec(props, b, Types.PLACED_CHARACTER));
        return <div onMouseEnter={() => preloadImage(b.img)} key={'character-' + b.i}><DragPreviewImage
            connect={preview} src={noImage}/>
            <div ref={drag} className='obj-thumb' style={{backgroundImage: 'url(' + b.thumb + ')'}}/>
        </div>;
    });
    if (!tbs) {
        tbs = [
            {
                i: fullTextBoxes.left,
                pos: placedButtonPosition.right,
                x: -0.5,
                y: 0,
                styles: {
                    textAlign: 'left',
                    verticalAlign: 'top',
                    wordBreak: 'break-word',
                    padding: 50,
                    paddingLeft: 100
                }

            },
            {
                i: fullTextBoxes.right,
                pos: placedButtonPosition.left,
                x: 55.5,
                y: 0,
                styles: {
                    textAlign: 'left',
                    verticalAlign: 'top',
                    wordBreak: 'break-word',
                    padding: 50,
                    paddingRight: 100
                }
            }].map((i) => {
            const [{isDragging}, drag, preview] = useDrag(getDragSpec(props, i, Types.PLACED_TEXTBOX_FULLSCREEN, {
                styles: i.styles,
                height: 100., width: 80., freeTransform: 'w', x: i.x, y: i.y, freeze: true, buttons: {
                    [placedButtons.flipW]: null,
                    [placedButtons.flipH]: null,
                    [placedButtons.zindexDown]: null,
                    [placedButtons.zindexUp]: null,
                    [placedButtons.flipH]: null,
                    [placedButtons.delete]: i.pos,
                }
            }));
            return <div key={'textbox-' + i.i}><DragPreviewImage
                connect={preview} src={noImage}/>
                <div ref={drag} className='obj-thumb'
                     style={{backgroundImage: 'url(' + require('assets/editor/textboxes/thumbs/' + i.i + '.webp') + ')'}}/>
            </div>;


        });
        tbs = tbs.concat(textBoxes.filter((b) => !hiddenTextboxes.has(b.i)).map((b, i) => {
            const [{isDragging}, drag, preview] = useDrag(getDragSpec(props, b, Types.PLACED_TEXTBOX));
            return <div onMouseEnter={() => preloadImage(b.img)} key={'textbox-' + b.i}><DragPreviewImage
                connect={preview} src={noImage}/>
                <div ref={drag} className='obj-thumb' style={{backgroundImage: 'url(' + b.thumb + ')'}}/>
            </div>;
        }));
    }

    switch (selected) {
        case 1:
            return bgs;
        case 2:
            return objs;
        case 3:
            return chrs;
        case 4:
            return tbs;

        default:
            return <span>todo</span>;
    }
}

function ToolsPaneView(props) {
    return (
        <div>
            <Flex row hAlign={'center'}
                  style={{
                      height: '50px',
                      borderBottom: '1px solid #979797',
                      width: '80vw',
                      marginLeft: '10vw',
                      marginBottom: '5px'
                  }}>
                {getTab(Localization.current.translation18, props.selectedTab === 1, () => props.onTabClick(1))}
                {getTab(Localization.current.translation19, props.selectedTab === 2, () => props.onTabClick(2))}
                {getTab(Localization.current.translation20, props.selectedTab === 3, () => props.onTabClick(3))}
                {getTab(Localization.current.translation21, props.selectedTab === 4, () => props.onTabClick(4))}
            </Flex>
            <Flex hide={props.selectedTab !== 1} row wrap hAlign={'center'} style={{
                overflowY: 'auto',
                overflowX: 'hidden',
                paddingLeft: '30px',
                paddingRight: '30px',
                maxHeight: 'calc(50vh - 60px)',
            }}>
                {
                    getTabContent(props, 1)
                }
            </Flex>
            <Flex hide={props.selectedTab !== 2} row wrap hAlign={'center'} style={{
                overflowY: 'auto',
                overflowX: 'hidden',
                paddingLeft: '30px',
                paddingRight: '30px',
                maxHeight: 'calc(50vh - 60px)',
            }}>
                {
                    getTabContent(props, 2)
                }
            </Flex>
            <Flex hide={props.selectedTab !== 3} row wrap hAlign={'center'} style={{
                overflowY: 'auto',
                overflowX: 'hidden',
                paddingLeft: '30px',
                paddingRight: '30px',
                maxHeight: 'calc(50vh - 60px)',
            }}>
                {
                    getTabContent(props, 3)
                }
            </Flex>
            <Flex hide={props.selectedTab !== 4} row wrap hAlign={'center'} style={{
                overflowY: 'auto',
                overflowX: 'hidden',
                paddingLeft: '30px',
                paddingRight: '30px',
                maxHeight: 'calc(50vh - 60px)',
            }}>
                {
                    getTabContent(props, 4)
                }
            </Flex>

            <div onClick={props.close} style={{cursor: 'pointer', position: 'absolute', top: 15, right: 15}}><Close/></div>
        </div>
    );
}

export default ToolsPaneView;